import type { FC } from 'react';
import { Children, cloneElement } from 'react';

import { useSmeGeoInfo } from '../form/context';

import type { IProps } from './models';

export const GeoField: FC<IProps> = ({ children, name }) => {
    const geo = useSmeGeoInfo();

    const child = Children.only(children);
    const { name: inputName } = child.props;

    return cloneElement(child, {
        name: inputName,
        value: geo && geo[name],
    });
};
